//don't add imports here, imported directly from main entry.
export const getMadeForFontUrl = (scriptsDomainUrl: string): string => {
  return `${scriptsDomainUrl}unpkg/@wix/wix-fonts@1.11.0/madefor.min.css`;
};
